import { createAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';

export const isolateAudioRequested = createAction<UserId>('localMute/isolateAudioRequested');
